import React from 'react';

const Item = (props) => {
    const { children, title, isLoading = false } = props;
    return (
        <div className="p-2 font-light text-gray-400">
            {title}
            <br />
            {!isLoading && (
                <span className="font-normal text-gray-700 text-lg">
                    {children}
                </span>
            )}
        </div>
    );
};

export default Item;
